import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    coords: {
        latitude: null,
        length: null
    },
    position: []
}

export const positionMapSlice = createSlice({
    name: 'positionMap',
    initialState,
    reducers: {
        setPositionMap: (state, action) => {
            state.position = action.payload
        },
        updatePositionMap: (state, action) => {
            state.coords[action.payload.coord] = action.payload.value
        }
    }
})

export const { setPositionMap, updatePositionMap } = positionMapSlice.actions
export default positionMapSlice.reducer
